import { FC, useContext } from "react";
import {
  BoardContext,
  TableContext,
  TeamContext,
  UserContext,
} from "../../../context";
import UpTokenCoin from "../../../assets/icons/upTokenCoin.svg";
import { generateLeftAndRightPositionDistance } from "./helpers";
import { DilemmaOwnerCrown } from "../../molecules";
import { IPlayer } from "../../../interfaces";

interface ITablePlayerMiniProfile {
  index: number;
  angleInDegrees: number;
  onePercentageOfBrowserWidth: number;
  player: IPlayer;
}

const TablePlayerMiniProfile: FC<ITablePlayerMiniProfile> = ({
  index,
  angleInDegrees,
  onePercentageOfBrowserWidth,
  player,
}) => {
  const { game } = useContext(TeamContext);
  const { isAvatarCheering, renderInitialCoins } = useContext(BoardContext);
  const { setEmailOfSelectedPlayerBoard } = useContext(UserContext);
  const {
    updateUserAngles,
    areAvatarsCurentlyResting,
    setAreAvatarsCurentlyResting,
	setAreAnimatedHandsShown,
	setStrengthCardsAnimationDuringAvatarRotation
  } = useContext(TableContext);
  const { bottom_position_of_profile_box, left_position_of_profile_box } = generateLeftAndRightPositionDistance(angleInDegrees, isAvatarCheering, game);
  const angleInRadians = (angleInDegrees * Math.PI) / 180.1;
  const angleMistakeInDegrees = 10;
  const adjustedAngleForUserMiniProfile =
    angleMistakeInDegrees * Math.sin(2 * angleInRadians);
  const lowerUserImageOn90Degrees = angleInDegrees === 90 ? "1vw" : "0";
  const distanceUserImageOn90Degrees = angleInDegrees === 90 ? "-1vh" : "0";
  const upperTokens = game?.gameInfo.players[player?.email]
    ? game?.gameInfo.players[player?.email]?.upperTokens
    : 0;

  let initialRippleAnimation = "";

  if (renderInitialCoins) {
    initialRippleAnimation = `animation_ripple animation_ripple_delay_${
      (index + 1) * 4
    } `;
  }

  const userProfile = () => {
    return (
		<div
			className={`table_player_mini_profile_wrapper center_vertically ${initialRippleAnimation}`}
		>
			<div className="table_player_mini_profile">
				<div
					className={`table_player_mini_profile_personal_data text_color_${player.color}`}
				>
					<div className="name">{player?.nickname}</div>
					<div className="user_tokens">
						<img
							className="upper_token_coin_icon"
							src={UpTokenCoin}
							alt="edit pen"
						/>
						<div className="upper_token_coin_text center_horizontally_and_vertically">
							{upperTokens}
						</div>
					</div>
				</div>
				<div className="table_player_mini_profile_image_and_crown_wrapper">
					<DilemmaOwnerCrown
						angleInDegrees={angleInDegrees}
						angleInRadians={angleInRadians}
						player={player}
					/>
					<img
						className={`table_player_mini_profile_image border_color_${player?.color}`}
						src={`${process.env.REACT_APP_BACKEND_URL}images/${player?.email}.png`}
						alt="Profile Icon"
					/>
				</div>
			</div>
		</div>
    );
  };

  const disableAvatarsRotationTemorarily = () => {
    setStrengthCardsAnimationDuringAvatarRotation(true);
	setAreAvatarsCurentlyResting(false);

    setTimeout(() => {
      	setAreAvatarsCurentlyResting(true);
		  setStrengthCardsAnimationDuringAvatarRotation(false);
    }, 3000);
  };

  const activateAnimationOfCardsWhileAvatarsRotate = () => {
	setAreAnimatedHandsShown(false)

	setTimeout(() => {
		setAreAnimatedHandsShown(true);
  }, 1000);
  }

  const seeTheSelectedUserCards = () => {
    if (areAvatarsCurentlyResting) {
		updateUserAngles(index);
		disableAvatarsRotationTemorarily();
		activateAnimationOfCardsWhileAvatarsRotate();
    }
  };

  const setChoosenPlayer = (email: any) => {
    if (areAvatarsCurentlyResting) {
      	setEmailOfSelectedPlayerBoard(email);
    }
  };

  return (
    <div
		className="center_horizontally_and_vertically user_mini_profile_xx"
		onClick={() => {
			// Rotation disabled and seeing other players cards
			//setChoosenPlayer(player.email);
			//seeTheSelectedUserCards();
		}}
		style={{ transform: `scale(${onePercentageOfBrowserWidth})` }}
    >
      <div
			className="user_mini_profile_rotation_box"
			style={{ transform: `rotate(${adjustedAngleForUserMiniProfile}deg)` }}
		>
			<div
			className="user_mini_profile_positioning_base"
			style={{
				bottom: `${distanceUserImageOn90Degrees}`,
				left: `${lowerUserImageOn90Degrees}`,
			}}
			>
				<div className="center_horizontally_and_vertically">
					<div style={{ position: "absolute", width: "100px", height: "100px" }}>
						<div className="center_horizontally_and_vertically">
							<div
								className="position_absolute"
								style={{
									transform: `rotate(${-(
									angleInDegrees + adjustedAngleForUserMiniProfile
									)}deg)`,
									left: `${left_position_of_profile_box}`,
									bottom: `${bottom_position_of_profile_box}`,
								}}
							>
								{userProfile()}
							</div>
						</div>
					</div>
				</div>
			</div>
      	</div>
    </div>
  );
};

export default TablePlayerMiniProfile;
